import XIcon from '../assets/xIcon'
import Minimise from '../assets/minimise'
import ExpandIcon from '../assets/expandIcon'
import ShrinkIcon from '../assets/shrinkIcon'
import BurgerIcon from '../assets/burgerIcon'
import CloseWidget from './closeWidget'
import useToggle from '../hooks/useToggle'
import { ShareButton } from './shareButton'

export default function Header({
    toggleIsActive,
    restart,
    config,
    isMobile,
    mainSizing,
    isExpanded,
    toggleIsExpanded,
    menuActive,
    toggleMenuActive,
    closeMenu,
    send,
    sender_id,
}) {
    const {
        title,
        width,
        header_bg_color,
        header_text_color,
        header_button_text_color,
        sponsor_enabled,
        default_sponsor_header_logo,
        sponsor_header_logo
    } = config

    const [showCloseMenu, toggleShowCloseMenu] = useToggle(false)

    const handleCloseWidget = () => {
        restart()
        toggleIsActive()
    }

    const handleClosePressed = () => {
        if (sessionStorage['feedbackSubmitted'] === 'true' || !sessionStorage['chatHistory']) {
            toggleIsActive()
        } else {
            toggleShowCloseMenu()
        }
    }

    const handleMenuPressed = () => {
        menuActive ? closeMenu() : toggleMenuActive(true)
    }

    return (
        <div
            className={'widgetHeader ' + (isMobile && 'mobile')}
            style={{ backgroundColor: header_bg_color, color: header_text_color, height: '5rem' }}
        >
            <div
                className='title'
                style={{ maxWidth: `calc(${width} - 114px)`, color: header_button_text_color, display: 'flex', flexDirection: 'row', alignItems: 'center' }}
            >
                {sponsor_enabled ? (
                    <>
                        {'Sponsored by '}
                        {'  '}
                        <img
                            src={sponsor_header_logo ? sponsor_header_logo : default_sponsor_header_logo}
                            alt={'sponsor'}
                        />
                    </>
                ) : (
                    <p>{title}</p>
                )}
            </div>

            <div
                className='buttonContainer'
                style={{ marginLeft: '10px' }}
            >
                <ShareButton
                    config={config}
                    sender_id={sender_id}
                />
                {sessionStorage['chatHistory'] && (
                    <BurgerIcon
                        stroke={header_button_text_color}
                        role='menu'
                        alt='menu'
                        className='ellipsis'
                        onClick={() => handleMenuPressed()}
                    />
                )}
                {!isMobile &&
                    (isExpanded ? (
                        <ShrinkIcon
                            stroke={header_button_text_color}
                            role='shrink'
                            alt='shrink'
                            className='refreshChat'
                            onClick={toggleIsExpanded}
                        />
                    ) : (
                        <ExpandIcon
                            stroke={header_button_text_color}
                            role='expand'
                            alt='expand'
                            className='refreshChat'
                            onClick={toggleIsExpanded}
                        />
                    ))}
                <Minimise
                    stroke={header_button_text_color}
                    role='minimise'
                    alt='minimise'
                    className='minimiseButton'
                    onClick={toggleIsActive}
                />
                <XIcon
                    stroke={header_button_text_color}
                    role='close'
                    alt='close'
                    className='closeButton'
                    onClick={handleClosePressed}
                />
                {showCloseMenu && (
                    <CloseWidget
                        config={config}
                        closeWidget={handleCloseWidget}
                        goBack={toggleShowCloseMenu}
                        send={send}
                        mainSizing={mainSizing}
                    />
                )}
            </div>
        </div>
    )
}
